import LogIn from "./Pages/Login/LogIn";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  BrowserRouter,
  Navigate,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";
import Messages from "./Pages/Messages/Messages";
import Transaction from "./Pages/Transaction/Transaction";
import ShareHolders from "./Pages/Shareholders/ShareHolders";
import Spends from "./Pages/Spends/Spends";
import Clients from "./Pages/Clients/Clients";
import Employees from "./Pages/Employees/Employees";
import ViewClient from "./Pages/Clients/ViewClient";
import ShareDistribution from "./Pages/Transaction/ShareDistribution";
import ViewTransaction from "./Pages/Transaction/ViewTransaction";
import PrivateRoute from "./Components/PrivateRoute";
import PublicRoute from "./Components/PublicRoute";
import Home from "./Components/Home";
import ViewShareHolder from "./Pages/Shareholders/ViewShareHolder";
import ViewSpends from "./Pages/Spends/ViewSpends";
import AddUpdateTransaction from "./Pages/Transaction/AddUpdateTransaction";
import AddUpdateShareHolder from "./Pages/Shareholders/AddUpdateShareHolder";
import AddUpdateClient from "./Pages/Clients/AddUpdateClient";
import ShareHoldersGroup from "./Pages/Shareholders/ShareHoldersGroup";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ViewShareHoldersGroup from "./Pages/Shareholders/ViewShareHoldersGroup";
import AddUpdateShareHolderGroup from "./Pages/Shareholders/AddUpdateShareHolderGroup";
import AddUpdateSalesinvoices from "./Pages/Invoices/SalesInvoices/AddUpdateSalesinvoices";
import ViewSalesinvoices from "./Pages/Invoices/SalesInvoices/ViewSalesinvoices";
import AddUpdatepurchaseinvoices from "./Pages/Invoices/PurchaseInvoices/AddUpdatepurchaseinvoices";
import ViewPurchaseinvoices from "./Pages/Invoices/PurchaseInvoices/ViewPurchaseinvoices";
import Purchaseinvoices from "./Pages/Invoices/PurchaseInvoices/Purchaseinvoices";
import EmploeeAddTask from "./Pages/Employees/Task/EmploeeAddEditTask";
import TaskEmployees from "./Pages/Employees/Task/TaskEmployees";
import ActivityEmployee from "./Pages/Employees/Activity/ActivityEmployee";
import AddUpdateLeave from "./Pages/Employees/Leave/AddUpdateLeave";
import Leave from "./Pages/Employees/Leave/Leave";
import LeaveQuota from "./Pages/Employees/Leave/LeaveQuota";
import ViewEmployee from "./Pages/Employees/ViewEmployee";
import AddEditEmployee from "./Pages/Employees/AddEditEmployee";
import EmployeeProfile from "./Pages/Profile/EmployeeProfile";
import EmployeeDocuments from "./Pages/Employees/Documents/EmployeeDocuments";
import ViewDocument from "./Pages/Employees/Documents/ViewDocument";
import EditProfile from "./Pages/Profile/EditProfile";
import EmployeeAppreciation from "./Pages/Employees/Appreciation/Appreciation";
import AddEmployeeAppreciation from "./Pages/Employees/Appreciation/AddAppreciation";
import EmployeeProject from "./Pages/Employees/Project/Project";
import ViewEmployeeProject from "./Pages/Employees/Project/ViewProject";
import Holiday from "./Pages/Holidays/Holiday";
import ViewHoliday from "./Pages/Holidays/ViewHoliday";
import AddEditHoliday from "./Pages/Holidays/AddEditHoliday";
import Leaves from "./Pages/Leaves/Leave";
import AddEditLeave from "./Pages/Leaves/AddEditLeave";
import ApproveRejectLeave from "./Pages/Leaves/ApproveRejectLeave";
import LeaveCalendar from "./Pages/Leaves/LeaveCalendar";
import ViewLeave from "./Pages/Leaves/ViewLeave";
import ViewEmployeeAppreciation from "./Pages/Employees/Appreciation/ViewAppreciation";
import EmployeeAwards from "./Pages/Employees/Appreciation/Awards";
import ViewEmployeeAward from "./Pages/Employees/Appreciation/ViewAward";
import ViewAppreciation from "./Pages/Award/ViewAppreciation";
import Award from "./Pages/Award/Award";
import ViewAwards from "./Pages/Award/ViewAward";
import Appreciation from "./Pages/Award/Appreciation";
import AddEditAppreciation from "./Pages/Award/AddEditAppreciations";
import Department from "./Pages/Department/Department";
import ViewDepartment from "./Pages/Department/ViewDepartment";
import Designation from "./Pages/Designation/Designation";
import AddUpdateDesignation from "./Pages/Designation/AddUpdateDesignation";
import ViewDesignation from "./Pages/Designation/ViewDesignation";
import Attendance from "./Pages/Attendance/Attendance";
import MarkAttendance from "./Pages/Attendance/MarkAttendance";
import Project from "./Pages/Project/Project";
import ViewProject from "./Pages/Project/ViewProject";
import ProjectTaskBoard from "./Pages/Project/ProjectTaskBoard";
import Setting from "./Pages/Settings/Settings";
import Tickets from "./Pages/Tickets/Tickets";
import CreateTicket from "./Pages/Tickets/CreateTicket";
import TicketView from "./Pages/Tickets/TicketView";
import TimeSheet from "./Pages/TimeSheet/TimeSheet";
import TimeSheetAddUpdateLog from "./Pages/TimeSheet/TimeSheetAddUpdateLog";
import ViewTimeSheet from "./Pages/TimeSheet/ViewTimeSheet";
import NoticeBoard from "./Pages/NoticeBoard/NoticeBoard";
import NoticeBoardView from "./Pages/NoticeBoard/NoticeBoardView";
import NoticeBoardAddEdit from "./Pages/NoticeBoard/NoticeBoardAddEdit";
import EmployeeViewTask from "./Pages/Employees/Task/EmployeeViewTask";
import AddEditAward from "./Pages/Award/AddEditAward";
import AddEditProject from "./Pages/Project/AddEditProject";
import AddUpdateProject from "./Pages/Employees/Project/AddUpdateProject";
import AddUpdateEmployee from "./Pages/Holidays/AddUpdateEmployee";
import AddUpdateAwards from "./Pages/Employees/Appreciation/AddUpdateAwards";
import EmployeeDashboard from "./Employee_Part/Pages/Dashboard/EmpDashboard";
import EmpTask from "./Employee_Part/Pages/Task/EmpTask";
import EmpTaskBoard from "./Employee_Part/Pages/Task/EmpTaskBoard";
import EmpTaskCalendar from "./Employee_Part/Pages/Task/EmpTaskCalendar";
import ViewEmpTask from "./Employee_Part/Pages/Task/ViewEmpTask";
import AddUpdateEmpTask from "./Employee_Part/Pages/Task/AddUpdateEmpTask";
import EmpProject from "./Employee_Part/Pages/Project/EmpProject";
import EmpProjectView from "./Employee_Part/Pages/Project/EmpProjectView";
import EmpProjectOverview from "./Employee_Part/Pages/Project/Overview/EmpProjectOverview";
import EmpProjectMember from "./Employee_Part/Pages/Project/Member/EmpProjectMember";
import EmpProjectFiles from "./Employee_Part/Pages/Project/Files/EmpProjectFiles";
import EmpProjectNotes from "./Employee_Part/Pages/Project/Notes/EmpProjectNotes";
import EmpProjectTask from "./Employee_Part/Pages/Project/Task/EmpProjectTask";
import EmpProjectActivity from "./Employee_Part/Pages/Project/Activity/EmpProjectActivity";
import EmpProjectAddFiles from "./Employee_Part/Pages/Project/Files/EmpProjectAddFiles";
import EmpProjectAddNotes from "./Employee_Part/Pages/Project/Notes/EmpProjectAddNotes";
import EmpProjectViewFiles from "./Employee_Part/Pages/Project/Files/EmpProjectViewFiles";
import EmpProjectViewNotes from "./Employee_Part/Pages/Project/Notes/EmpProjectViewNotes";
import EmpProjectAddTask from "./Employee_Part/Pages/Project/Task/EmpProjectAddTask";
import EmpProjectViewTask from "./Employee_Part/Pages/Project/Task/EmpProjectViewTask";
import EmpDocument from "./Employee_Part/Pages/Document/EmpDocument";
import EmpSalary from "./Employee_Part/Pages/Salary/EmpSalary";
import EmpSalarySlips from "./Employee_Part/Pages/Salary/EmpSalarySlips";
import EmpSalaryHistory from "./Employee_Part/Pages/Salary/EmpSalaryHistory";
import EmpLeave from "./Employee_Part/Pages/Leave/EmpLeave";
import EmpLeaveAddEdit from "./Employee_Part/Pages/Leave/EmpLeaveAdd";
import EmpLeaveView from "./Employee_Part/Pages/Leave/EmpLeaveView";
import EmpLeaveCalendar from "./Employee_Part/Pages/Leave/EmpLeaveCalendar";
import EmpAddDocumentModal from "./Employee_Part/Pages/Document/EmpAddDocumentModal";
import EmpAttendance from "./Employee_Part/Pages/Attendance/EmpAttendance";
import EditEmpSalarySlips from "./Employee_Part/Pages/Salary/EditEmpSalarySlips";
import TaskReport from "./Pages/Report/TaskReport";
import AttendanceReport from "./Pages/Report/AttendanceReport";
import MultipleLeaveView from "./Pages/Employees/Leave/MultipleLeaveView";
import Specialday from "./Pages/Specialday/Specialday";
import AddEditSpecialday from "./Pages/Specialday/AddEditSpecialday";
import ViewSpecialday from "./Pages/Specialday/ViewSpecialday";
import Sidebarlayout from "./Layouts/Sidebarlayout";
import EmployeeTimesheet from "./Pages/Employees/Timesheet/EmployeeTimesheet";
import EmpTimeSheetAddUpdate from "./Pages/Employees/Timesheet/EmpTimeSheetAddUpdate";
import ViewEmpTimesheet from "./Pages/Employees/Timesheet/ViewEmpTimesheet";
import ViewEmpSalarySlip from "./Employee_Part/Pages/Salary/ViewEmpSalarySlip";
import AddSalaryRevision from "./Employee_Part/Pages/Salary/AddSalaryRevision";
import GenerateSalarySlip from "./Employee_Part/Pages/Salary/GenerateSalarySlip";
import EmpDocumentView from "./Employee_Part/Pages/Document/EmpDocumentView";
import Reminder from "./Pages/Reminder/Reminder";
import ReminderAddEdit from "./Pages/Reminder/ReminderAddEdit";
import ReminderView from "./Pages/Reminder/ReminderView";
import 'react-loading-skeleton/dist/skeleton.css'
import WaterJug from "./Pages/WaterJug/WaterJug";
import AddUpdateWaterJug from "./Pages/WaterJug/AddUpdateWaterJug";
import ViewWaterJug from "./Pages/WaterJug/ViewWaterJug";
import EmpTaskByHour from "./Employee_Part/Pages/Attendance/EmpTaskByHour";

const SidebarLayoutWrapper = () => {
  return (
    <PrivateRoute
      element={
        <Sidebarlayout>
          <Outlet />
        </Sidebarlayout>
      }
    />
  );
};
function App() {
  return (
    <BrowserRouter>
      <ToastContainer hideProgressBar={true} />
      <Routes>
        <Route path="/" element={<PublicRoute element={<Home />} />} />
        <Route path="/login" element={<PublicRoute element={<LogIn />} />} />
        <Route path="" element={<SidebarLayoutWrapper />}>
          <Route
            path="/employee/dashboard"
            element={<PrivateRoute element={<EmployeeDashboard />} />}
          />
          <Route
            path="/salesinvoices/add"
            element={<PrivateRoute element={<AddUpdateSalesinvoices />} />}
          />
          <Route
            path="/salesinvoices/edit"
            element={<PrivateRoute element={<AddUpdateSalesinvoices />} />}
          />
          <Route
            path="/salesinvoices/view"
            element={<PrivateRoute element={<ViewSalesinvoices />} />}
          />
          <Route
            path="/purchaseinvoices"
            element={<PrivateRoute element={<Purchaseinvoices />} />}
          />
          <Route
            path="/purchaseinvoices/add"
            element={<PrivateRoute element={<AddUpdatepurchaseinvoices />} />}
          />
          <Route
            path="/purchaseinvoices/edit"
            element={<PrivateRoute element={<AddUpdatepurchaseinvoices />} />}
          />
          <Route
            path="/purchaseinvoices/view"
            element={<PrivateRoute element={<ViewPurchaseinvoices />} />}
          />
          <Route
            path="/messages"
            element={<PrivateRoute element={<Messages />} />}
          />
          <Route
            path="/transaction"
            element={<PrivateRoute element={<Transaction />} />}
          />
          <Route
            path="/shareholder"
            element={<PrivateRoute element={<ShareHolders />} />}
          />
          <Route
            path="/shareholder/group"
            element={<PrivateRoute element={<ShareHoldersGroup />} />}
          />
          <Route
            path="/shareholder/group/add"
            element={<PrivateRoute element={<AddUpdateShareHolderGroup />} />}
          />
          <Route
            path="/shareholder/group/edit"
            element={<PrivateRoute element={<AddUpdateShareHolderGroup />} />}
          />
          <Route
            path="/shareholder/group/view"
            element={<PrivateRoute element={<ViewShareHoldersGroup />} />}
          />
          <Route
            path="/spends"
            element={<PrivateRoute element={<Spends />} />}
          />
          <Route
            path="/spends/view"
            element={<PrivateRoute element={<ViewSpends />} />}
          />
          <Route
            path="/clients"
            element={<PrivateRoute element={<Clients />} />}
          />
          <Route
            path="/clients/add"
            element={<PrivateRoute element={<AddUpdateClient />} />}
          />
          <Route
            path="/clients/edit"
            element={<PrivateRoute element={<AddUpdateClient />} />}
          />
          <Route
            path="/clients/view"
            element={<PrivateRoute element={<ViewClient />} />}
          />
          <Route
            path="/transaction/add"
            element={<PrivateRoute element={<AddUpdateTransaction />} />}
          />
          <Route
            path="/transaction/edit"
            element={<PrivateRoute element={<AddUpdateTransaction />} />}
          />
          <Route
            path="/transaction/view"
            element={<PrivateRoute element={<ViewTransaction />} />}
          />
          <Route
            path="/transaction/ShareDistribution"
            element={<PrivateRoute element={<ShareDistribution />} />}
          />
          <Route
            path="/employees"
            element={<PrivateRoute element={<Employees />} />}
          />
          <Route
            path="/employees/add"
            element={<PrivateRoute element={<AddEditEmployee />} />}
          />
          <Route
            path="/employees/edit"
            element={<PrivateRoute element={<AddEditEmployee />} />}
          />
          <Route
            path=""
            element={<PrivateRoute element={<AddUpdateEmployee />} />}
          />
          <Route
            path="/report/task"
            element={<PrivateRoute element={<TaskReport />} />}
          />
          <Route
            path="/report/attendance"
            element={<PrivateRoute element={<AttendanceReport />} />}
          />

          <Route
            path="/employees/view"
            element={<PrivateRoute element={<ViewEmployee />} />}
          >
            <Route
              path=""
              element={<Navigate to="/employees/view/profile/:employeeId" />}
            />
            <Route
              path="/employees/view/:employeeId/timesheet"
              element={<PrivateRoute element={<EmployeeTimesheet />} />}
            />
            <Route
              path="/employees/view/:employeeId/timesheet/add"
              element={<PrivateRoute element={<EmpTimeSheetAddUpdate />} />}
            />
            <Route
              path="/employees/view/:employeeId/timesheet/edit"
              element={<PrivateRoute element={<EmpTimeSheetAddUpdate />} />}
            />
            <Route
              path="/employees/view/:employeeId/timesheet/view"
              element={<PrivateRoute element={<ViewEmpTimesheet />} />}
            />
            <Route
              path="/employees/view/:employeeId/task/timesheet"
              element={<PrivateRoute element={<EmployeeTimesheet />} />}
            />
            <Route
              path="/employees/view/:employeeId/task/timesheet/add"
              element={<PrivateRoute element={<EmpTimeSheetAddUpdate />} />}
            />
            <Route
              path="/employees/view/:employeeId/task/timesheet/edit"
              element={<PrivateRoute element={<EmpTimeSheetAddUpdate />} />}
            />
            <Route
              path="/employees/view/:employeeId/task/timesheet/view"
              element={<PrivateRoute element={<ViewEmpTimesheet />} />}
            />
            <Route
              path="/employees/view/:employeeId/task"
              element={<PrivateRoute element={<TaskEmployees />} />}
            />
            <Route
              path="/employees/view/:employeeId/task/taskboards"
              element={<PrivateRoute element={<TaskEmployees />} />}
            />
            <Route
              path="/employees/view/:employeeId/task/add"
              element={<PrivateRoute element={<AddUpdateEmpTask />} />}
            />
            <Route
              path="/employees/view/:employeeId/task/edit"
              element={<PrivateRoute element={<AddUpdateEmpTask />} />}
            />
            <Route
              path="/employees/view/:employeeId/activity"
              element={<PrivateRoute element={<ActivityEmployee />} />}
            />
            <Route
              path="/employees/view/:employeeId/leave"
              element={<PrivateRoute element={<Leave />} />}
            />
            <Route
              path="/employees/view/:employeeId/leave/view/multiple"
              element={<PrivateRoute element={<MultipleLeaveView />} />}
            />
            <Route
              path="/employees/view/:employeeId/leave/add"
              element={<PrivateRoute element={<AddUpdateLeave />} />}
            />
            <Route
              path="/employees/view/:employeeId/leave/edit"
              element={<PrivateRoute element={<AddUpdateLeave />} />}
            />
            <Route
              path="/employees/view/:employeeId/leave/view"
              element={<PrivateRoute element={<EmpLeaveView />} />}
            />
            <Route
              path="/employees/view/:employeeId/leave/leaveQuota"
              element={<PrivateRoute element={<LeaveQuota />} />}
            />
            <Route
              path="/employees/view/:employeeId/leave/leaveQuota/edit"
              element={<PrivateRoute element={<LeaveQuota />} />}
            />
            <Route
              path="/employees/view/profile/:employeeId"
              element={<PrivateRoute element={<EmployeeProfile />} />}
            />
            <Route
              path="/employees/view/:employeeId/profile/edit"
              element={<PrivateRoute element={<EditProfile />} />}
            />
            <Route
              path="/employees/view/:employeeId/document"
              element={<PrivateRoute element={<EmployeeDocuments />} />}
            />
            <Route
              path="/employees/view/:employeeId/document/view"
              element={<PrivateRoute element={<ViewDocument />} />}
            />
            <Route
              path="/employees/view/:employeeId/appreciation"
              element={<PrivateRoute element={<EmployeeAppreciation />} />}
            />
            <Route
              path="/employees/view/:employeeId/appreciation/add"
              element={<PrivateRoute element={<AddEmployeeAppreciation />} />}
            />
            <Route
              path="/employees/view/:employeeId/appreciation/edit"
              element={<PrivateRoute element={<AddEmployeeAppreciation />} />}
            />
            <Route
              path="/employees/view/:employeeId/appreciation/view"
              element={<PrivateRoute element={<ViewEmployeeAppreciation />} />}
            />
            <Route
              path="/employees/view/:employeeId/award"
              element={<PrivateRoute element={<EmployeeAwards />} />}
            />
            <Route
              path="/employees/view/:employeeId/award/add"
              element={<PrivateRoute element={<AddUpdateAwards />} />}
            />
            <Route
              path="/employees/view/:employeeId/award/edit"
              element={<PrivateRoute element={<AddUpdateAwards />} />}
            />
            <Route
              path="/employees/view/:employeeId/award/view"
              element={<PrivateRoute element={<ViewEmployeeAward />} />}
            />
            <Route
              path="/employees/view/:employeeId/project"
              element={<PrivateRoute element={<EmployeeProject />} />}
            />
            <Route
              path="/employees/view/:employeeId/project/add"
              element={<PrivateRoute element={<AddUpdateProject />} />}
            />
            <Route
              path="/employees/view/:employeeId/project/edit"
              element={<PrivateRoute element={<AddUpdateProject />} />}
            />
            <Route
              path="/employees/view/:employeeId/project/view/:projectId"
              element={<PrivateRoute element={<ViewEmployeeProject />} />}
            />
            <Route
              path="/employees/view/:employeeId/task/view/:id"
              element={<PrivateRoute element={<ViewEmpTask />} />}
            // element={<PrivateRoute element={<EmployeeViewTask />} />}
            />
            {/* <Route
              path="/employees/view/task/edit"
              element={<PrivateRoute element={<EmploeeAddTask />} />}
            /> */}

            <Route
              path="/employees/view/:employeeId/project/view/:projectId"
              element={<PrivateRoute element={<EmpProjectView />} />}
            >
              <Route
                path=""
                element={
                  <Navigate to="/employees/view/:employeeId/project/view/:projectId/overview" />
                }
              />
              <Route
                path="overview"
                element={<PrivateRoute element={<EmpProjectOverview />} />}
              />
              <Route
                path="member"
                element={<PrivateRoute element={<EmpProjectMember />} />}
              />
              <Route
                path="files"
                element={<PrivateRoute element={<EmpProjectFiles />} />}
              />
              <Route
                path="files/add"
                element={<PrivateRoute element={<EmpProjectAddFiles />} />}
              />
              <Route
                path="files/view"
                element={<PrivateRoute element={<EmpProjectViewFiles />} />}
              />
              <Route
                path="notes"
                element={<PrivateRoute element={<EmpProjectNotes />} />}
              />
              <Route
                path="notes/add"
                element={<PrivateRoute element={<EmpProjectAddNotes />} />}
              />
              <Route
                path="notes/view"
                element={<PrivateRoute element={<EmpProjectViewNotes />} />}
              />
              <Route
                path="task"
                element={<PrivateRoute element={<EmpProjectTask />} />}
              />
              <Route
                path="task/add"
                element={<PrivateRoute element={<EmpProjectAddTask />} />}
              />
              <Route
                path="task/edit"
                element={<PrivateRoute element={<EmpProjectAddTask />} />}
              />
              <Route
                path="task/view/:id"
                element={<PrivateRoute element={<ViewEmpTask />} />}
              />
              <Route
                path="activity"
                element={<PrivateRoute element={<EmpProjectActivity />} />}
              />
            </Route>
          </Route>

          <Route
            path="/project/employeeproject"
            element={<PrivateRoute element={<EmpProject />} />}
          />
          <Route
            path="/project/employeeproject/add"
            element={<PrivateRoute element={<AddUpdateProject />} />}
          />
          <Route
            path="/project/employeeproject/edit"
            element={<PrivateRoute element={<AddUpdateProject />} />}
          />
          <Route
            path="/project/employeeproject/view/:projectId"
            element={<PrivateRoute element={<EmpProjectView />} />}
          >
            <Route
              path=""
              element={<Navigate to="/project/employeeproject/view/:projectId/overview" />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/overview"
              element={<PrivateRoute element={<EmpProjectOverview />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/member"
              element={<PrivateRoute element={<EmpProjectMember />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/files"
              element={<PrivateRoute element={<EmpProjectFiles />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/files/add"
              element={<PrivateRoute element={<EmpProjectAddFiles />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/files/view"
              element={<PrivateRoute element={<EmpProjectViewFiles />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/notes"
              element={<PrivateRoute element={<EmpProjectNotes />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/notes/add"
              element={<PrivateRoute element={<EmpProjectAddNotes />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/notes/view"
              element={<PrivateRoute element={<EmpProjectViewNotes />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/task"
              element={<PrivateRoute element={<EmpProjectTask />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/task/add"
              element={<PrivateRoute element={<EmpProjectAddTask />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/task/edit"
              element={<PrivateRoute element={<EmpProjectAddTask />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/task/view/:id"
              element={<PrivateRoute element={<ViewEmpTask />} />}
            />
            <Route
              path="/project/employeeproject/view/:projectId/activity"
              element={<PrivateRoute element={<EmpProjectActivity />} />}
            />
          </Route>

          <Route
            path="/salary/empsalary"
            element={<PrivateRoute element={<EmpSalary />} />}
          >
            <Route
              path=""
              element={<Navigate to="/salary/empsalary/salaryslips" />}
            />
            <Route
              path="/salary/empsalary/salaryslips/generateslip"
              element={<PrivateRoute element={<GenerateSalarySlip />} />}
            />
            <Route
              path="/salary/empsalary/salaryslips/edit"
              element={<PrivateRoute element={<EditEmpSalarySlips />} />}
            />
            <Route
              path="/salary/empsalary/salaryslips/view"
              element={<PrivateRoute element={<ViewEmpSalarySlip />} />}
            />
            <Route
              path="/salary/empsalary/salaryslips"
              element={<PrivateRoute element={<EmpSalarySlips />} />}
            />
            {/* <Route
              path="/salary/empsalary/salaryhistory"
              element={<PrivateRoute element={<EmpSalaryHistory />} />}
            /> */}
            {/* <Route
              path="/salary/empsalary/salaryhistory/add"
              element={<PrivateRoute element={<AddSalaryRevision />} />}
            /> */}
          </Route>

          <Route
            path="/attendance/empattendance"
            element={<PrivateRoute element={<EmpAttendance />} />}
          />
          <Route
            path="/attendance/empmember"
            element={<PrivateRoute element={<EmpAttendance />} />}
          />
          <Route
            path="/attendance/empdetails"
            element={<PrivateRoute element={<EmpAttendance />} />}
          />
          <Route
            path="/attendance/empbyhour"
            element={<PrivateRoute element={<EmpAttendance />} />}
          />
          <Route
            path="/attendance/empbylocation"
            element={<PrivateRoute element={<EmpAttendance />} />}
          />
          <Route
            path="/attendance/emptaskbyhour"
            element={<PrivateRoute element={<EmpAttendance />} />}
          />

          <Route
            path="/leave/empleave"
            element={<PrivateRoute element={<EmpLeave />} />}
          />
          <Route
            path="/leave/empleave/add"
            element={<PrivateRoute element={<EmpLeaveAddEdit />} />}
          />
          <Route
            path="/leave/empleave/edit"
            element={<PrivateRoute element={<EmpLeaveAddEdit />} />}
          />
          <Route
            path="/leave/empleave/view/:id"
            element={<PrivateRoute element={<EmpLeaveView />} />}
          />
          <Route
            path="/leave/empleave/view/multiple"
            element={<PrivateRoute element={<MultipleLeaveView />} />}
          />
          <Route
            path="/leave/empleave/empcalendar"
            element={<PrivateRoute element={<EmpLeaveCalendar />} />}
          />

          <Route
            path="/document/empdocument"
            element={<PrivateRoute element={<EmpDocument />} />}
          />
          <Route
            path="/document/empdocument/add"
            element={<PrivateRoute element={<EmpAddDocumentModal />} />}
          />
          <Route
            path="/document/empdocument/edit"
            element={<PrivateRoute element={<EmpAddDocumentModal />} />}
          />
          <Route
            path="/document/empdocument/view"
            element={<PrivateRoute element={<EmpDocumentView />} />}
          />

          <Route
            path="/task/emptask"
            element={<PrivateRoute element={<EmpTask />} />}
          />
          <Route
            path="/task/emptaskboard"
            element={<PrivateRoute element={<EmpTaskBoard />} />}
          />
          <Route
            path="/task/emptaskcalendar"
            element={<PrivateRoute element={<EmpTaskCalendar />} />}
          />
          <Route
            path="/task/emptask/view/:id"
            element={<PrivateRoute element={<ViewEmpTask />} />}
          />
          <Route
            path="/task/emptask/add"
            element={<PrivateRoute element={<AddUpdateEmpTask />} />}
          />
          <Route
            path="/task/emptask/edit"
            element={<PrivateRoute element={<AddUpdateEmpTask />} />}
          />

          <Route
            path="/setting"
            element={<PrivateRoute element={<Setting />} />}
          />

          <Route
            path="/waterjug"
            element={<PrivateRoute element={<WaterJug />} />}
          />
          <Route
            path="/waterjug/add"
            element={<PrivateRoute element={<AddUpdateWaterJug />} />}
          />
          <Route
            path="/waterjug/edit"
            element={<PrivateRoute element={<AddUpdateWaterJug />} />}
          />
          <Route
            path="/waterjug/view"
            element={<PrivateRoute element={<ViewWaterJug />} />}
          />

          <Route
            path="/reminder"
            element={<PrivateRoute element={<Reminder />} />}
          />

          <Route
            path="/reminder/add"
            element={<PrivateRoute element={<ReminderAddEdit />} />}
          />

          <Route
            path="/reminder/edit"
            element={<PrivateRoute element={<ReminderAddEdit />} />}
          />
          <Route
            path="/reminder/view/:id"
            element={<PrivateRoute element={<ReminderView />} />}
          />

          <Route
            path="/project"
            element={<PrivateRoute element={<Project />} />}
          />
          <Route
            path="/project/add"
            element={<PrivateRoute element={<AddEditProject />} />}
          />
          <Route
            path="/project/edit"
            element={<PrivateRoute element={<AddEditProject />} />}
          />
          <Route
            path="/project/view"
            element={<PrivateRoute element={<ViewProject />} />}
          />
          <Route
            path="/project/projecttaskboard"
            element={<PrivateRoute element={<ProjectTaskBoard />} />}
          />

          <Route
            path="/department"
            element={<PrivateRoute element={<Department />} />}
          />
          <Route
            path="/department/view"
            element={<PrivateRoute element={<ViewDepartment />} />}
          />
          <Route
            path="/departmenthierarchy"
            element={<PrivateRoute element={<Department />} />}
          />

          <Route path="/award" element={<PrivateRoute element={<Award />} />} />
          <Route
            path="/award/add"
            element={<PrivateRoute element={<AddEditAward />} />}
          />
          <Route
            path="/award/edit"
            element={<PrivateRoute element={<AddEditAward />} />}
          />
          <Route
            path="/award/view"
            element={<PrivateRoute element={<ViewAwards />} />}
          />

          <Route
            path="/appreciation"
            element={<PrivateRoute element={<Appreciation />} />}
          />
          <Route
            path="/appreciation/add"
            element={<PrivateRoute element={<AddEditAppreciation />} />}
          />
          <Route
            path="/appreciation/edit"
            element={<PrivateRoute element={<AddEditAppreciation />} />}
          />
          <Route
            path="/appreciation/view"
            element={<PrivateRoute element={<ViewAppreciation />} />}
          />

          <Route
            path="/shareholder/add"
            element={<PrivateRoute element={<AddUpdateShareHolder />} />}
          />
          <Route
            path="/shareholder/edit"
            element={<PrivateRoute element={<AddUpdateShareHolder />} />}
          />
          <Route
            path="/shareholder/view"
            element={<PrivateRoute element={<ViewShareHolder />} />}
          />

          <Route
            path="/employee/view"
            element={<PrivateRoute element={<ViewEmployee />} />}
          />

          <Route
            path="/holiday"
            element={<PrivateRoute element={<Holiday />} />}
          />
          <Route
            path="/holiday/calendar"
            element={<PrivateRoute element={<Holiday />} />}
          />
          <Route
            path="/holiday/view"
            element={<PrivateRoute element={<ViewHoliday />} />}
          />
          <Route
            path="/holiday/add"
            element={<PrivateRoute element={<AddEditHoliday />} />}
          />
          <Route
            path="/holiday/edit"
            element={<PrivateRoute element={<AddEditHoliday />} />}
          />

          <Route
            path="/leave"
            element={<PrivateRoute element={<Leaves />} />}
          />
          <Route
            path="/leave/add"
            element={<PrivateRoute element={<AddEditLeave />} />}
          />
          <Route
            path="/leave/edit"
            element={<PrivateRoute element={<AddEditLeave />} />}
          />
          <Route
            path="/leave/view"
            element={<PrivateRoute element={<ViewLeave />} />}
          />
          <Route
            path="/leave/calendar"
            element={<PrivateRoute element={<LeaveCalendar />} />}
          />
          <Route
            path="/leave/approve"
            element={<PrivateRoute element={<ApproveRejectLeave />} />}
          />
          <Route
            path="/leave/reject"
            element={<PrivateRoute element={<ApproveRejectLeave />} />}
          />

          <Route
            path="/designation"
            element={<PrivateRoute element={<Designation />} />}
          />
          <Route
            path="/designation/chart"
            element={<PrivateRoute element={<Designation />} />}
          />
          <Route
            path="/designation/add"
            element={<PrivateRoute element={<AddUpdateDesignation />} />}
          />
          <Route
            path="/designation/edit"
            element={<PrivateRoute element={<AddUpdateDesignation />} />}
          />
          <Route
            path="/designation/view"
            element={<PrivateRoute element={<ViewDesignation />} />}
          />

          <Route
            path="/ticket"
            element={<PrivateRoute element={<Tickets />} />}
          />
          <Route
            path="/ticket/add"
            element={<PrivateRoute element={<CreateTicket />} />}
          />
          <Route
            path="/ticket/view"
            element={<PrivateRoute element={<TicketView />} />}
          />
          <Route
            path="/ticket/view/reply"
            element={<PrivateRoute element={<TicketView />} />}
          />

          <Route
            path="/attendance"
            element={<PrivateRoute element={<Attendance />} />}
          />
          <Route
            path="/attendance/member"
            element={<PrivateRoute element={<Attendance />} />}
          />
          <Route
            path="/attendance/details"
            element={<PrivateRoute element={<Attendance />} />}
          />
          <Route
            path="/attendance/byhour"
            element={<PrivateRoute element={<Attendance />} />}
          />
          <Route
            path="/attendance/bylocation"
            element={<PrivateRoute element={<Attendance />} />}
          />
          <Route
            path="/attendance/markattendance"
            element={<PrivateRoute element={<MarkAttendance />} />}
          />

          <Route
            path="/timelogs"
            element={<PrivateRoute element={<TimeSheet />} />}
          />
          <Route
            path="/timelogs/calendar"
            element={<PrivateRoute element={<TimeSheet />} />}
          />
          <Route
            path="/timelogs/employee"
            element={<PrivateRoute element={<TimeSheet />} />}
          />
          <Route
            path="/timelogs/add"
            element={<PrivateRoute element={<TimeSheetAddUpdateLog />} />}
          />
          <Route
            path="/timelogs/edit"
            element={<PrivateRoute element={<TimeSheetAddUpdateLog />} />}
          />
          <Route
            path="/timelogs/view"
            element={<PrivateRoute element={<ViewTimeSheet />} />}
          />

          <Route
            path="/notice"
            element={<PrivateRoute element={<NoticeBoard />} />}
          />
          <Route
            path="/notice/view"
            element={<PrivateRoute element={<NoticeBoardView />} />}
          />
          <Route
            path="/notice/edit"
            element={<PrivateRoute element={<NoticeBoardAddEdit />} />}
          />
          <Route
            path="/notice/add"
            element={<PrivateRoute element={<NoticeBoardAddEdit />} />}
          />

          <Route
            path="/specialday"
            element={<PrivateRoute element={<Specialday />} />}
          />
          <Route
            path="/specialday/calendar"
            element={<PrivateRoute element={<Specialday />} />}
          />
          <Route
            path="/specialday/view"
            element={<PrivateRoute element={<ViewSpecialday />} />}
          />
          <Route
            path="/specialday/add"
            element={<PrivateRoute element={<AddEditSpecialday />} />}
          />
          <Route
            path="/specialday/edit"
            element={<PrivateRoute element={<AddEditSpecialday />} />}
          />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
